(() => {
  if (customElements.get('renao-magnet-personalizer')) return;
  customElements.define('renao-magnet-personalizer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.closest('form');
      this.product = this.closest('product-info');
      this.variants = JSON.parse(this.querySelector('[data-magnet-variants]').textContent);
      this.renaoValidate = () => this.validate();
      this.onVariant = () => this.sync();
      this.form.querySelector('[name="id"]')?.addEventListener('change', this.onVariant);
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        if (String(data.sectionId) === this.dataset.sectionId) this.sync();
      });
      this.onUpload = (event) => {
        const error = this.querySelector('[data-magnet-error]');
        error.hidden = true;
        if (event.target.matches('[data-magnet-bulk]')) {
          const files = [...event.target.files];
          if (!files.length) return;
          if (files.length > 5) {
            error.textContent = 'En fazla 5 fotoğraf seçebilirsin.';
            error.hidden = false;
            event.target.value = '';
            return;
          }
          this.querySelectorAll('[data-magnet-digital]').forEach((input, index) => {
            const transfer = new DataTransfer();
            if (files[index]) transfer.items.add(files[index]);
            input.files = transfer.files;
          });
          event.target.value = '';
        }
        this.updateUploads();
      };
      this.addEventListener('change', this.onUpload);
      this.sync();
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.removeEventListener('change', this.onUpload);
      this.form?.querySelector('[name="id"]')?.removeEventListener('change', this.onVariant);
      this.ready = false;
    }
    sync() {
      const id = this.form.querySelector('[name="id"]')?.value;
      const variant = this.variants.find(v => String(v.id) === String(id));
      this.nfc = /nfc/i.test(variant?.title || '');
      const album = this.querySelector('[data-magnet-album]');
      album.hidden = !this.nfc;
      album.disabled = !this.nfc;
      const extra = this.querySelector('[data-magnet-extra]');
      if (extra) { extra.hidden = !this.nfc; extra.disabled = !this.nfc; }
      this.classList.toggle('magnet-personalizer-empty', this.hasAttribute('data-magnet-fixed') && !this.nfc);
      this.querySelector('[data-magnet-model]').value = this.nfc ? 'NFC’li Magnet' : 'Normal Magnet';
      if (!this.nfc) album.querySelectorAll('input').forEach(input => { input.value = ''; });
      this.querySelector('[data-magnet-error]').hidden = true;
      this.updateUploads();
      // NFC-only media can be marked by alt text on any future magnet.
      const phonePattern = /nfc.only|0e7b02ed|fb7bdc54/i;
      document.querySelectorAll('media-gallery li[data-media-id], media-gallery li[data-target], product-modal [data-media-id]').forEach(item => {
        const img = item.querySelector('img');
        const nfcOnly = phonePattern.test((img?.alt || '') + ' ' + (img?.src || ''));
        item.classList.toggle('magnet-nfc-hidden', nfcOnly && !this.nfc);
      });
      this.product?.querySelectorAll('slider-component').forEach(slider => slider.initPages?.());
    }
    updateUploads() {
      const print = this.querySelector('[data-magnet-print]');
      const hasPrint = Boolean(print?.files?.length);
      if (print) this.querySelector('[data-magnet-print-count]').textContent = hasPrint ? '1/1' : '0/1';
      if (print) this.querySelector('[data-magnet-print-label]').textContent = hasPrint ? 'Fotoğrafı değiştir' : 'Fotoğraf seç';
      let count = 0;
      this.querySelectorAll('[data-magnet-digital]').forEach(input => {
        const filled = Boolean(input.files?.length);
        if (filled) count++;
        const slot = input.closest('.magnet-album-slot');
        slot.classList.toggle('is-filled', filled);
        slot.querySelector('[data-magnet-slot-icon]').textContent = filled ? '✓' : '+';
        slot.querySelector('[data-magnet-slot-status]').textContent = filled ? 'Değiştir' : 'Ekle';
        slot.querySelector('label').title = input.files?.[0]?.name || '';
      });
      this.querySelector('[data-magnet-album-count]').textContent = `${count}/5`;
    }
    validMusicLink(value) {
      try {
        const url = new URL(value.trim());
        return url.protocol === 'https:' && ['open.spotify.com', 'spotify.link', 'youtu.be', 'youtube.com', 'www.youtube.com', 'music.youtube.com'].includes(url.hostname);
      } catch { return false; }
    }
    validate() {
      this.sync();
      let message = '';
      const location = this.querySelector('renao-magnet-location');
      const print = this.querySelector('[data-magnet-print]');
      if (location && !location.isConfirmed?.()) message = 'Konumunu arama sonuçlarından seç.';
      else if (print && !print.files?.length) message = 'Baskı fotoğrafını seç.';
      else if (this.nfc && this.querySelector('[data-magnet-message]') && !this.querySelector('[data-magnet-message]').value.trim()) message = 'Dijital mesajını yaz.';
      else if (this.nfc && this.querySelector('[data-magnet-music]') && !this.validMusicLink(this.querySelector('[data-magnet-music]').value)) message = 'Geçerli bir Spotify veya YouTube bağlantısı ekle.';
      else if (this.nfc && ![...this.querySelectorAll('[data-magnet-digital]')].some(input => input.files?.length)) message = 'Albüm için en az 1 fotoğraf seç.';
      else if ([...this.querySelectorAll('input[type="file"]')].some(input => input.files?.[0]?.size > 20 * 1024 * 1024)) message = 'Her fotoğraf en fazla 20 MB olmalıdır.';
      const error = this.querySelector('[data-magnet-error]');
      error.textContent = message;
      error.hidden = !message;
      if (message) this.scrollIntoView({behavior:'smooth',block:'center'});
      return message;
    }
  });
})();
